import { StringService } from '@smarttask-common/src/lib/services/General/string.service';
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'error-main',
    templateUrl: './error.html',
    styleUrls: ['./error.scss'],
    imports: [],
})
export class ErrorComponent {
    @Input() title = 'SmartTask Error';
    @Input() not_found = false;

    error_title?: string;
    error_message?: string;
    error_description?: string;

    is_browser = false;

    constructor(
        @Inject(PLATFORM_ID) private platformId: object,
        private stringService: StringService,
    ) {
        this.is_browser = isPlatformBrowser(this.platformId);
        if (!this.is_browser) {
            return;
        }

        if (window.location.href.includes('not-found')) {
            this.not_found = true;
        }

        // Extract hash params like #error=invalid_request&message=abc
        const hash = window.location.hash.startsWith('#') ? window.location.hash.substring(1) : window.location.hash;

        const params = new URLSearchParams(hash);

        this.error_title = params.get('error') ?? '';
        this.error_title = this.stringService.snakeCaseToPlainText(this.error_title);
        this.error_message = params.get('message') ?? undefined;
        this.error_description = params.get('error_description') ?? '';
        this.error_description = decodeURIComponent(this.error_description.replace(/\+/g, ' '));

        window.history.replaceState({}, 'SmartTask Error', '/');
    }
}
